module.exports = __webpack_public_path__ + "img/appgenesis.90ac50ca.png";